import React from "react";
import Color from "../Color";

function Defs() {
  return (
    <defs>
      <linearGradient
        id="gradient"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
        spreadMethod="pad"
      >
        <stop offset="0%" stopColor={Color.gradientLight} stopOpacity="1" />
        <stop offset="100%" stopColor={Color.gradientDark} stopOpacity="1" />
      </linearGradient>
      <filter id="colorMeSaturate">
        <feColorMatrix in="SourceGraphic" type="saturate" values="0.3" />
      </filter>
      <filter id="colorMeHueRotate">
        <feColorMatrix in="SourceGraphic" type="hueRotate" values="-25" />
      </filter>
    </defs>
  );
}

export default Defs;
